var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVelo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#af975c;}.cls-2{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a_velo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,23.52a7.92,7.92,0,0,0-2.81.52l2.62,5a2.42,2.42,0,0,0-1.7.89l-2.63-5A8,8,0,1,0,42,23.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,25.27a6.2,6.2,0,0,0-2,.33l1.8,3.45a2.42,2.42,0,0,0-1.7.89L38.33,26.5A6.21,6.21,0,1,0,42,25.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,32.45a2.55,2.55,0,0,0,0-1.93h5.65a8,8,0,0,0-2.51-4.89l-3.31,4.59a2.45,2.45,0,0,0-1.56-1.13l3.31-4.59a8,8,0,1,0,4.07,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,32.45a2.55,2.55,0,0,0,0-1.93h3.88a6.27,6.27,0,0,0-1.77-3.46l-2.28,3.16a2.45,2.45,0,0,0-1.56-1.13l2.27-3.15a6.12,6.12,0,0,0-2.8-.67,6.22,6.22,0,1,0,6.14,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.48,31.49A2.45,2.45,0,1,1,42,29,2.45,2.45,0,0,1,44.48,31.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,31.49a1,1,0,1,1-1-1A1,1,0,0,1,43,31.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.9,27.93a3.56,3.56,0,1,0,3.56,3.56A3.56,3.56,0,0,0,28.9,27.93Zm0,5.43a1.88,1.88,0,1,1,1.88-1.87A1.88,1.88,0,0,1,28.9,33.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.72,
    cy: 31.49,
    r: 2.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.68,31.49a1,1,0,1,1-1-1A1,1,0,0,1,14.68,31.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.48,
    y: 16.21,
    width: 6.99,
    height: 1.72,
    rx: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.49,30.52H16a2.55,2.55,0,0,1,0,1.93h9.51a3.18,3.18,0,0,1,0-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.06,19.91v-2h2.08v.5a1,1,0,1,0,1.93,0V17a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v2.22H22.08l-.57-.86-.25-.39H19l.25.39,1.33,2-6.29,8.73a2.45,2.45,0,0,1,1.56,1.13l5.85-8.12L25.46,28l.78,1.2a3.51,3.51,0,0,1,1.61-1l-.78-1.2-3.74-5.79h11l-3.67,5.77-.77,1.21a3.59,3.59,0,0,1,1.63,1l.76-1.21L36,22.07l4.12,7.87a2.42,2.42,0,0,1,1.7-.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVelo);
export default __webpack_public_path__ + "static/media/icon_velo.aa30fe8c7f40499b48878033e052ff4e.svg";
export { ForwardRef as ReactComponent };